export default class FBPixel {
    constructor() {
        const pageTitle = document.querySelector('h1');
        this.title = pageTitle ? pageTitle.textContent : '';
    }

    track(type, args) {
        if (typeof window.fbq !== 'function') {
            return;
        }
        window.fbq('track', type, args);
    }

    onContentView(location) {
        const locations = ['categories', 'product', 'articles'];

        if (locations.indexOf(location) === -1) {
            return;
        }

        this.track('ViewContent', {
            content_name: this.title
        });
    }

    onCheckoutStart(args) {
        this.withCurrency('InitiateCheckout', args);
    }

    onCheckoutEnd(args) {
        this.withCurrency('Purchase', args);
    }

    onOneClickBuyEnd(args) {
        this.onCheckoutEnd(args);
    }

    onSearch(args) {
        this.track('Search', args);
    }

    onSignUp() {
        this.track('Lead');
    }

    onSignUpEnd() {
        this.withCurrency('CompleteRegistration', {
            value: 100
        });
    }

    onAddToCart(args) {
        this.withCurrency('AddToCart', args);
    }

    onAddToFav(args) {
        this.withCurrency('AddToWishlist', {
            ...args,
            content_name: this.title
        });
    }

    withCurrency(type, args = {}) {
        this.track(type, {
            ...args,
            currency: 'RUB'
        });
    }
}



// WEBPACK FOOTER //
// ./blocks/tracker/fbpixel.js